import { render, staticRenderFns } from "./mini.vue?vue&type=template&id=6454f6d0&scoped=true&"
import script from "./mini.vue?vue&type=script&lang=js&"
export * from "./mini.vue?vue&type=script&lang=js&"
import style0 from "./mini.vue?vue&type=style&index=0&id=6454f6d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6454f6d0",
  null
  
)

export default component.exports